import { DeviceStatusEnum, LocationDetailTab } from '@core/models';
import { TabViewModel } from '@core/models/tab-view.model';

export const LOCATION_DETAIL_TABS = [
  {
    index: LocationDetailTab.General,
    title: 'locations.detailTabs.general.label',
    icon: 'domain',
  },
  {
    index: LocationDetailTab.Company,
    title: 'locations.detailTabs.company.label',
    icon: 'star',
  },
  {
    index: LocationDetailTab.Devices,
    title: 'locations.detailTabs.devices.label',
    icon: 'router',
  },
];

export const LOCATION_DETAIL_TABS_VIEW: Array<TabViewModel> = [
  { index: LocationDetailTab.General, title: 'locations.detailTabs.general.label', route: 'general' },
];

export const DEVICE_STATUS = [
  {
    index: DeviceStatusEnum.Operational,
    label: 'locations.filter.deviceStatus.operational',
  },
  {
    index: DeviceStatusEnum.InMaintenance,
    label: 'locations.filter.deviceStatus.inMaintenance',
  },
  {
    index: DeviceStatusEnum.NotInstalled,
    label: 'locations.filter.deviceStatus.notInstalled',
  },
  {
    index: DeviceStatusEnum.Offline,
    label: 'locations.filter.deviceStatus.offline',
  },
  {
    index: DeviceStatusEnum.Error,
    label: 'locations.filter.deviceStatus.error',
  },
];
